(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initAccordion = (root = document) => {
      root.querySelectorAll('.accordion[data-single-open="true"]').forEach((accordion) => {
        const detailsElements = Array.from(accordion.querySelectorAll('details'));
        if (!detailsElements.length) return;

        const closeOthers = (current) => {
          detailsElements.forEach((detail) => {
            if (detail !== current && detail.open) {
              detail.removeAttribute('open');
            }
          });
        };

        detailsElements.forEach((detail) => {
          detail.addEventListener('toggle', () => {
            if (detail.open) {
              closeOthers(detail);
            }
          });
        });
      });
    };

    initAccordion();
    document.addEventListener('shopify:section:load', (event) => {
      initAccordion(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
